import { mutatorAction } from 'satcheljs';
import type ClassificationViewState from 'owa-mail-protection-types/lib/schema/classification/ClassificationViewState';
import type MessageClassificationType from 'owa-service/lib/contract/MessageClassificationType';

export default mutatorAction(
    'setMessageClassification',
    (viewState: ClassificationViewState, classificationToSet: MessageClassificationType) => {
        viewState.messageClassification = classificationToSet;
    }
);
